import { useQuery } from '@hooks/reactQuery';

import { getProjectsStatuses } from '@api/projectManagement';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_STATUSES } from '@constants/queryKeys';

interface IUseQueryProjectStatusesReturned {
	projectsStatuses: Array<TSelectOption>;
	isLoadingProjectsStatuses: boolean;
}

export const useQueryPlatformOwnerProjectStatuses = (): IUseQueryProjectStatusesReturned => {
	const {
		data: projectsStatuses,
		isLoading: isLoadingProjectsStatuses,
		isFetching: isFetchingProjectsStatuses,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_STATUSES],
		queryFn: getProjectsStatuses,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectsStatuses: projectsStatuses || [],
		isLoadingProjectsStatuses: isLoadingProjectsStatuses || isFetchingProjectsStatuses,
	};
};
